import ApiService from "../../api/api.service";
import { CANCEL_SUBSCRIPTION, GET_FAMILY_MEMBER_LIST, DELETE_FAMILY_MEMBER, GET_FAMILY_MEMBER_DETAIL,
UPDATE_FAMILY_MEMBER_DETAIL, GET_USER_PROFILE_DETAIL, SAVE_FAMILY_MEMBER_DETAIL, UPDATE_USER_PROFILE_DETAIL,
CHANGE_PASSWORD, GET_PLAN_DETAIL, GET_NOTIFICATION_LIST, DELETE_NOTIFICATION_DATA } from "../actions.type";

const getDefaultProfileState = () => {
	return {
		cancelSubscription: {},
		familyMemberList: {},
		deleteFamilyMember: {},
		familyMemberDetail: {},
		updatefamilyMemberDetail: {},
		userProfileDetail: {},
		saveFamilyMemberDetail: {},
		updateUserProfileDetail: {},
		changePassword: {},
		planDetail: {},
		noticationList: {},
	}
};

const state = getDefaultProfileState();

const getters = {

	getCancelSubscriptionData(state) {
		return state.cancelSubscription;
	},
	getFamilyMemberList(state) {
		return state.familyMemberList;
	},
	getDeleteFamilyMember(state) {
		return state.deleteFamilyMember;
	},
	getFamilyMemberDetail(state) {
		return state.familyMemberDetail;
	},
	getUpdatefamilyMemberDetail(state) {
		return state.updatefamilyMemberDetail;
	},
	getUserProfileDetail(state) {
		return state.userProfileDetail;
	},
	getSaveFamilyMemberDetail(state) {
		return state.saveFamilyMemberDetail;
	},
	getUpdateUserProfileDetail(state) {
		return state.updateUserProfileDetail;
	},
	getChangePassword(state) {
		return state.changePassword;
	},
	getPlanDetail(state) {
		return state.planDetail;
	},
	getNotificationList(state) {
		return state.noticationList;
	},

};

const mutations = {

	setCancelSubscriptionData (state, data) {
		state.cancelSubscription = data
	},
	setFamilyMemberList (state, data) {
		state.familyMemberList = data
	},
	setDeleteFamilyMember (state, data) {
		state.deleteFamilyMember = data
	},
	setFamilyMemberDetail (state, data) {
		state.familyMemberDetail = data
	},
	setUpdatefamilyMemberDetail (state, data) {
		state.updatefamilyMemberDetail = data
	},
	setUserProfileDetail (state, data) {
		state.userProfileDetail = data
	},
	setSaveFamilyMemberDetail (state, data) {
		state.saveFamilyMemberDetail = data
	},
	setUpdateUserProfileDetail (state, data) {
		state.updateUserProfileDetail = data
	},
	setChangePassowrd (state, data) {
		state.changePassword = data
	},
	setPlanDetail (state, data) {
		state.planDetail = data
	},
	setNotificationList (state, data) {
		state.noticationList = data
	},

};


const actions = {

	[CANCEL_SUBSCRIPTION](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCancelSubscriptionData',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_FAMILY_MEMBER_LIST](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setFamilyMemberList',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[DELETE_FAMILY_MEMBER](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setDeleteFamilyMember',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_FAMILY_MEMBER_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setFamilyMemberDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_FAMILY_MEMBER_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdatefamilyMemberDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_USER_PROFILE_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUserProfileDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[SAVE_FAMILY_MEMBER_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSaveFamilyMemberDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_USER_PROFILE_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdateUserProfileDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[CHANGE_PASSWORD](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setChangePassowrd',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_PLAN_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPlanDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_NOTIFICATION_LIST](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setNotificationList',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[DELETE_NOTIFICATION_DATA](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setDeleteFamilyMember',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},

};

export default {
	getters,
	actions,
	mutations,
	state
}